// ════════════════════════════════════════════════════════════════════════════
//  PantallaConRed.jsx — la red debajo de cada pantalla de la app
//
//  ── POR QUÉ EXISTE (19-09-2026) ────────────────────────────────────────────
//  Rob: «en el dashboard, Perfil me manda pantalla en blanco, algo se rompió».
//  Y tenía razón: un perfil con `purposes` en NULL hacía reventar una línea al
//  pintar las casillas. Pero lo GRAVE no era esa línea —se arregla en un
//  minuto—, sino lo que pasaba después: sin nada que atrapara el error, React
//  desmonta el árbol entero y el alumno se queda mirando una pantalla vacía,
//  sin cabecera, sin menú y sin una sola palabra que le diga qué pasó.
//
//  Eso convierte cualquier fallo pequeño en un fallo total, y además lo hace
//  invisible: el alumno no reporta «me falla el perfil», reporta «no me carga»
//  —o no reporta nada y se va—.
//
//  Con esta red, un fallo se queda DENTRO de su pantalla: lo que la rodea
//  sigue en pie, el alumno lee qué pasó y puede reintentar, y nosotros nos
//  enteramos por la consola con el nombre de la pantalla delante.
//
//  ── 20-09-2026 ─────────────────────────────────────────────────────────────
//  Volvió a pasar, y fuera del dashboard: `/evaluacion` se quedaba en blanco
//  porque un resultado guardado con la forma vieja no traía unas etiquetas que
//  la pantalla daba por seguras. Por eso esta red dejó de ser del dashboard y
//  pasó a envolver también las pantallas sueltas del alumno.
// ════════════════════════════════════════════════════════════════════════════
import React from 'react';

class PantallaConRed extends React.Component {
    constructor(props) {
        super(props);
        this.state = { fallo: null };
    }

    static getDerivedStateFromError(error) {
        return { fallo: error };
    }

    componentDidCatch(error, info) {
        // Con el nombre de la sección delante: «[dashboard] preferences …».
        console.error(`[dashboard] la sección «${this.props.seccion}» falló:`,
            error, info?.componentStack);
    }

    componentDidUpdate(prevProps) {
        // Cambiar de sección limpia el fallo: si se queda pegado, el alumno ve
        // el aviso de Perfil mientras mira su suscripción.
        if (prevProps.seccion !== this.props.seccion && this.state.fallo) {
            this.setState({ fallo: null });
        }
    }

    render() {
        if (!this.state.fallo) return this.props.children;
        return (
            <div className="dp-progress-card dp-neumorphic" data-prueba="seccion-rota">
                <h2 className="dp-section-title">Esta parte no cargó</h2>
                <p>
                    Algo falló al abrir <strong>{this.props.nombre || 'esta sección'}</strong>.
                    El resto de la aplicación sigue funcionando: puedes seguir
                    usándola con el menú de arriba.
                </p>
                <p style={{ fontSize: 12, opacity: 0.7 }}>
                    Ya quedó apuntado para el equipo de NSL. Si te corre prisa,
                    escríbenos por el chat y lo vemos contigo.
                </p>
                <button className="ps-btn" onClick={() => this.setState({ fallo: null })}>
                    Intentar de nuevo
                </button>
            </div>
        );
    }
}

export default PantallaConRed;
